import { TypographyVariants } from '@lyearn/ui';
import { GroupItemMode } from '@/modules/corporate/modules/group/types';

type GroupClassesConfigType = {
  [key in GroupItemMode]: {
    root: string;
    container?: string;
    name: { variant: TypographyVariants };
    description?: { className?: string; variant?: TypographyVariants };
  };
};

export const GROUP_TAB_CLASSES: GroupClassesConfigType = {
  compact: {
    root: 'space-s-8 truncate',
    container: 'truncate',
    name: { variant: 'body-short-02' },
    description: { className: 'hidden' },
  },
  normal: {
    root: 'space-s-16 max-w-full min-w-0 me-12 truncate',
    container: 'space-y-4 truncate',
    name: { variant: 'body-short-01' },
  },
  'normal-small': {
    root: 'space-s-20 truncate group/assign',
    container: 'space-y-4 truncate',
    name: { variant: 'body-short-02' },
    description: { variant: 'body-short-03' },
  },
};
